import { PremiumFeatureAccessLevel } from '@sdk/authentication/types';
import { SLING_PREMIUM } from '@sdk/account/constants';

import { ACCESS_LEVEL_NAMES } from '@web/premiumGuard/ModalGuard/modalGuard.consts';

type Props = {
  premiumFeatureAccessLevel: PremiumFeatureAccessLevel;
  isOldPremium: boolean;
  isToastBilling: boolean;
};

// TODO refactor getPremiumAccessLevelName - object argument makes no sense
const getPremiumAccessLevelName = ({
  premiumFeatureAccessLevel,
  isOldPremium,
  isToastBilling,
}: Props): string => {
  if (isToastBilling) {
    return 'Scheduling Pro';
  }

  if (isOldPremium) {
    return ACCESS_LEVEL_NAMES[SLING_PREMIUM];
  }

  return ACCESS_LEVEL_NAMES[premiumFeatureAccessLevel];
};

export default getPremiumAccessLevelName;
